/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportReportingImmediatelyGnvert$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * The provider data to filter
 */
  provider?: string;
}

export function exportReportingImmediatelyGnvert(http: HttpClient, rootUrl: string, params: ExportReportingImmediatelyGnvert$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, exportReportingImmediatelyGnvert.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('provider', params.provider, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

exportReportingImmediatelyGnvert.PATH = '/custom/subscriptions/{uid}/reports/gnvert';
